// Решает, должна ли клавиша Enter в поле ввода отправить сообщение или быть перенесена браузеру
// как обычная клавиша (перенос строки) — по модели Telegram, с двумя режимами. Чистая функция,
// без DOM: вызывающая сторона сама решает, preventDefault() и что значит «отправить».

export const SEND_HOTKEY_MODES = {
    ENTER: 'enter',
    CTRL_ENTER: 'ctrl-enter',
};

// Сознательное отступление от Telegram: в режиме 'enter' Ctrl/Cmd+Enter тоже отправляет, а не
// переносит строку. Причина — Ctrl+Enter не вставляет перенос строки нативно ни в textarea, ни в
// contenteditable, а ручная вставка \n по позиции каретки ломает undo, выделение и синхронизацию
// с v-model. Поэтому в обоих режимах перенос строки — только то, что и так уже умеет браузер
// нативно (Shift+Enter, а в режиме 'ctrl-enter' — и обычный Enter), без единой ручной вставки.
export function resolveEnterAction({ ctrlKey, metaKey, shiftKey, isComposing, repeat }, mode) {
    // isComposing — идёт набор составного символа через IME (например, при вводе иероглифов):
    // Enter в этот момент подтверждает вариант в IME, а не должен трактоваться приложением.
    // repeat — автоповтор зажатой клавиши: без этой проверки удержание Enter/Ctrl+Enter слало бы
    // событие на каждый повтор.
    if (isComposing || repeat) {
        return 'default';
    }

    const ctrlOrCmd = ctrlKey || metaKey;

    if (mode === SEND_HOTKEY_MODES.CTRL_ENTER) {
        return ctrlOrCmd ? 'send' : 'default';
    }

    // mode === 'enter' — в том числе любое иное/отсутствующее значение: пока настройка не
    // загружена, поведение обязано быть сегодняшним (см. RequestViewTabChat.vue).
    return shiftKey ? 'default' : 'send';
}
